export default "__VITE_ASSET__DW6Tl2EN__"